import type { HeadingLevel } from '../MpfInput/MpfInputBaseProps';

export type MpfCareCardVariant = 'non-urgent' | 'urgent' | 'emergency';

export interface MpfCareCardProps {
  variant?: MpfCareCardVariant;
  heading?: string;
  srPrefix?: string;
  headingLevel?: HeadingLevel;
  marginClass?: string;
}

export const mpfCareCardDefaults = {
  variant: 'non-urgent',
  heading: 'Speak to a GP if:',
  headingLevel: 2 as HeadingLevel,
} satisfies Partial<MpfCareCardProps>;
